export const badges = [
  { id: 1, name: 'Bronze', level: 1, image: 'badges/bronze.png' },
  { id: 2, name: 'Prata', level: 2, image: 'badges/prata.png' },
  { id: 71, name: 'Ouro', level: 3, image: 'badges/ouro.png' },
  { id: 4, name: 'Diamante', level: 5, image: 'badges/diamante.png' },
  { id: 6, name: 'Safira', level: 4, image: 'badges/safira.png' },
];
